// FacebookCatalogFeed.EntryPoint.js
define(
    'FacebookCatalogFeed.EntryPoint'
    , [
        'jQuery'
    ]
    , function (
        jQuery
    ) {
        'use strict';

        return {
            mountToApp: function mountToApp(container) {
                var pdp = container.getComponent("PDP");
                var layout = container.getComponent('Layout');

                if (layout) {

                    layout.modifyViewJsonLd('ProductDetails.Full.View', function (json) {
                        var item = this.options.application.getComponent('PDP').getItemInfo();
                        var offers = json.offers;
                        offers.itemCondition = 'https://schema.org/NewCondition';

                        json = _.extend(json, {
                            '@context': 'https://schema.org',
                            'url': item.item.urlcomponent,
                            'productID': item.item.itemid,
                            'brand': item.item.custitem_dhi_brand,
                            'offers': offers
                        });                       

                        return json;
                    });
                }
            }
        };
    }
);
